import {
  WorkflowNodeData,
  WorkflowNodeTypes,
  SettingParamTypes,
} from "@/types/node";
import {Node} from "@xyflow/react";

export const branchNodeBlueprint: Partial<Node<WorkflowNodeData>> = {
  type: WorkflowNodeTypes.BRANCH,
  position: {x: 0, y: 0},
  measured: {height: 38, width: 340},
  data: {
    type: WorkflowNodeTypes.BRANCH,
    settingsTitle: "Branch",
    onChange: () => {
      console.log("Start node changed");
    },
    isEmpty: true,
    settings: [
      {
        title: "General",
        params: [
          {
            label: "Branch Name",
            placeholder: "Enter Branch name",
            type: SettingParamTypes.INPUT,
            key: "name",
            value: "",
          },
          {
            label: "When to go here",
            placeholder: "Describe when to take this branch",
            type: SettingParamTypes.PROMPT,
            key: "description",
            value: "",
          },
        ],
      },
    ],
  },
};
